import "./OurProcess.module.css";
import Header from "@/reusable_sections/Header";
import ProcessHero from "./sections/ProcessHero";
import RestorationProcess from "./sections/RestorationProcess";
import Emergency from "./sections/Emergency";
import Footer from "@/reusable_sections/Footer";
export default function OurProcessPage() {
  return <div>
      <Header />
      <ProcessHero />
      <RestorationProcess />
      <Emergency />
      <Footer />
    </div>;
}